import Navigation from '../home/components/Navigation';
import Footer from '../home/components/Footer';
import MotionWrapper from '../../components/base/MotionWrapper';

const ClientBillingPortalPage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F8F4EF' }}>
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <MotionWrapper>
            <h1 
              className="text-4xl lg:text-5xl font-bold mb-6"
              style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
            >
              Manage your billing
            </h1>
            <p 
              className="text-xl lg:text-2xl leading-relaxed max-w-3xl mx-auto mb-6"
              style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
            >
              Securely view invoices, update your payment method, and manage your retainer — all in one place.
            </p>
            <p 
              className="text-base leading-relaxed max-w-2xl mx-auto"
              style={{ color: '#7B6655', fontFamily: 'Inter, sans-serif' }}
            >
              Powered by Stripe. We never store your full card details on our servers.
            </p>
          </MotionWrapper>
        </div>
      </section>

      {/* Main Billing Portal Card */}
      <section className="pb-16">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <MotionWrapper delay={100}>
            <div className="bg-white rounded-3xl p-8 lg:p-12 shadow-sm border text-center" style={{ borderColor: '#E6DACD' }}>
              <h2 
                className="text-2xl lg:text-3xl font-bold mb-6"
                style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
              >
                Access your billing portal
              </h2>
              
              <p 
                className="text-lg leading-relaxed mb-8 max-w-2xl mx-auto"
                style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
              >
                Use the button below to open your secure Stripe billing portal. From there you can:
              </p>

              <div className="text-left max-w-lg mx-auto mb-10">
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div 
                      className="w-2 h-2 rounded-full mr-4 mt-2 flex-shrink-0"
                      style={{ backgroundColor: '#7B6655' }}
                    ></div>
                    <p 
                      className="text-lg leading-relaxed"
                      style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
                    >
                      View and download past invoices
                    </p>
                  </div>

                  <div className="flex items-start">
                    <div 
                      className="w-2 h-2 rounded-full mr-4 mt-2 flex-shrink-0"
                      style={{ backgroundColor: '#7B6655' }}
                    ></div>
                    <p 
                      className="text-lg leading-relaxed"
                      style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
                    >
                      Update your payment method
                    </p>
                  </div>

                  <div className="flex items-start">
                    <div 
                      className="w-2 h-2 rounded-full mr-4 mt-2 flex-shrink-0"
                      style={{ backgroundColor: '#7B6655' }}
                    ></div>
                    <p 
                      className="text-lg leading-relaxed"
                      style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
                    >
                      Update billing details (name, email, address)
                    </p>
                  </div>
                </div>
              </div>

              <a
                href="https://billing.stripe.com/p/login/4gMeVeegs5Ft91w37e1Jm00"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-10 py-4 rounded-xl font-semibold text-white transition-all duration-200 hover:opacity-90 whitespace-nowrap cursor-pointer"
                style={{ 
                  backgroundColor: '#7B6655',
                  fontFamily: 'Manrope, Inter, sans-serif'
                }}
              >
                <i className="ri-external-link-line mr-3 text-lg"></i>
                Open Billing Portal
              </a>
            </div>
          </MotionWrapper>
        </div>
      </section>

      {/* Help Section */}
      <section className="pb-20">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
          <MotionWrapper delay={200}>
            <h3 
              className="text-xl lg:text-2xl font-semibold mb-6"
              style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
            >
              Need help with billing?
            </h3>
            
            <p 
              className="text-lg leading-relaxed max-w-2xl mx-auto"
              style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
            >
              If you have any questions about invoices, retainers, or payments, email us at{' '}
              <a 
                href="mailto:david@nextphaseworkflows.com"
                className="font-semibold hover:opacity-80 transition-opacity cursor-pointer"
                style={{ color: '#7B6655' }}
              >
                david@nextphaseworkflows.com
              </a>
              {' '}and we'll be happy to help.
            </p>
          </MotionWrapper>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ClientBillingPortalPage;